//? styles
import Card from "../UI/Card";
import styles from "./Profile.module.css";
const Profile = (props) => {
  const { name, age, picture } = props;
  return (
    <Card
      className={
        styles["birthday-container__profile"]
      }
    >
      <div className={styles["image"]}>
        <img src={picture} alt="person" />
      </div>
      <div className={styles["details"]}>
        <h2>{name}</h2>
        <h4>{age + " years"}</h4>
      </div>
    </Card>
  );
};

export default Profile;
